import { useEffect } from 'react';

import { useConfigPedidoStepContext } from 'pages/compra/configuracao-pedido/contexts';

export function useConfigPedidoDirty(dirty: boolean) {
    const { setActiveStepDirty } = useConfigPedidoStepContext();

    useEffect(() => {
        setActiveStepDirty(dirty);
    }, [dirty]);
}
